import { random } from 'lodash';

export enum LogViewerTableColumnType {
  NetworkBodyWithJq,
}

export abstract class LogViewerTableColumnDefinition {
  abstract get type(): LogViewerTableColumnType;

  private _uniqueId: string;
  get uniqueId(): string {
    return this._uniqueId;
  }

  onChange?: () => void;
  onDeleteRequest?: () => void;

  constructor() {
    this._uniqueId = `${new Date().toISOString()}_${random()}`;
  }
}

export class LogViewerTableNetworkBodyWithJqColumnDefinition extends LogViewerTableColumnDefinition {
  get type(): LogViewerTableColumnType {
    return LogViewerTableColumnType.NetworkBodyWithJq;
  }

  private _jqQuery: string;
  get jqQuery(): string {
    return this._jqQuery;
  }

  set jqQuery(v: string) {
    this._jqQuery = v;
    if (this.onChange) {
      this.onChange();
    }
  }

  constructor(jqQuery: string) {
    super();
    this._jqQuery = jqQuery;
  }
}
